import Select from 'react-select';
import { useEffect, useState, useContext } from 'react';
import { useBackOffice, BackOfficeContext } from '../../contexts/BackOfficeContext';
import '../../styles/LoadingTable.css';
import api from '../../services/api.js';

function GroupFilter() {

    const { groups, selectedGroup } = useContext(BackOfficeContext);
    const { handleSetGroups, handleSelectedGroup } = useBackOffice();

    const [loading, setLoading] = useState(true); // 🔴 ALTERADO: nome mais padrão (antes era isLoading)

    useEffect(() => {

        async function getGroups() {

            try { // 🔴 ALTERADO: adicionei try/catch (boa prática)

                const response = await api.get('/userGroups', {
                    timeout: 7000
                });

                handleSetGroups(
                    response.data.map(item => ({
                        value: item.id,
                        label: item.name
                    }))
                );

            } catch (error) {
                console.log('Erro ao buscar grupos:', error); // 🔴 ALTERADO
            } finally {
                setLoading(false); // 🔴 ALTERADO: antes era isLoading(false)
            }

        }

        getGroups();

    }, [handleSetGroups]); // 🔴 ALTERADO: antes era [] (faltava dependência)

    // insert the first value on select
    useEffect(() => {

        // 🔴 ALTERADO: agora garante que groups existe e não está vazio
        if (!selectedGroup && groups.length > 0) {
            handleSelectedGroup(groups[0]);
        }

    }, [groups, selectedGroup, handleSelectedGroup]); // 🔴 ALTERADO: antes estava [handleSetGroups] (errado)

    return (
        <>
            {loading ? (

                <div className="one flex flex-col w-[40%] h-[38px] rounded-[6px] border-[solid] border-[1px] border-[#E0E0E0]"></div>
            ) : (

                <div className="flex flex-col w-[40%]">
                    <Select
                        isSearchable={false}

                        value={selectedGroup || null} 
                        // 🔴 ALTERADO: antes era defaultValue={groups[0]}
                        // agora o Select é controlado corretamente

                        options={groups}
                        onChange={handleSelectedGroup}
                        classNamePrefix="select"
                    />
                </div>
            )}
        </>
    );
}

export default GroupFilter;